


























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import dealRouterPath from '@/common/filters/dealRoutePath';
import CONFIG from '@/common/config';
import { isXiaomaiApp } from '@/common/utils/getPlaform';
import fetch from '@/common/api/fetch';
@Component({
  components: {}
})
export default class DemoFooter extends Vue {
  @Getter('buttonSection') buttonSection!: object;
  @Getter('showFooter') showFooter!: boolean;
  @Getter('supportPay') supportPay!: boolean;

  // @Getter('wechatMiniOnlineStatus') wechatMiniOnlineStatus!: string;
  // @Getter('xmPayRegisterStatusEnum') xmPayRegisterStatusEnum!: string;

  type: string = getUrlParam('type') as string;
  templateId: string = getUrlParam('id') as string;

  showXcxQecodeModal: boolean = false;
  xcxQrcodeUrl: string = ''; // 小程序二维码链接
  isXiaomaiApp: Function = isXiaomaiApp;
  activityType: string = getActivityType() as string;
  instId: string = getUrlParam('instId') as string;
  needPayList: any = ['bargainType', 'groupType', 'lessonType', 'solitaireType']; // 需要付款类型小麦秀
  fromApp: boolean = getUrlParam('enterType') === 'APP' || false;
  enterType: string = getUrlParam('enterType') as string;
  XMCounter: boolean = true;
  mounted() {
    this.checkUserPermission();
  }
  // 获取小程序太阳码链接
  getXcxQrcode() {
    let host: string = CONFIG.localServerB;
    if (process.env.NODE_ENV === 'production') {
      host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
    }

    return `${host}business/anon/show/getEditXcxCode?templateId=${this.templateId}`;
  }

  checkXmPay(): void {
    if (this.instId && this.instId !== 'undefined') {
      fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
        const { wechatMiniOnlineStatus, xmPayRegisterStatusEnum } = res.result;
        if (this.needPayList.indexOf(this.activityType) > -1) {
          if (xmPayRegisterStatusEnum !== 'SUCCESS') {
            // 未开通小麦收银
            Vue.$confirm({
              title: '温馨提示',
              text: '小麦秀收款需开通小麦收银，且完成小麦收银-微信认证，如需收款请联系主账号前往小麦助教APP开通小麦收银后完成认证后再来发布小麦秀。',
              cancleText: '继续制作',
              cancle: () => {
                this.handleToMakeup();
              },
              okText: '去开通',
              ok: () => {
                if (this.fromApp) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  if (xmPayRegisterStatusEnum === 'AUDIT_FAIL') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=fail&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else if (xmPayRegisterStatusEnum === 'AUDIT_PROGRESS') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=waiting&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else {
                    location.href =
                      'https://mp.weixin.qq.com/s?__biz=MzIxNDEyODIxMA==&mid=2654820994&idx=1&sn=f7ca68831e0dea08ceb689a5de468112&chksm=8c65b9bfbb1230a994aa2e4147fd96022dc39a66a30b5273c3980ea2cbfab7d44ae43b2e1823#rd';
                  }
                } else {
                  window.open(
                    'https://mp.weixin.qq.com/s?__biz=MzIxNDEyODIxMA==&mid=2654820994&idx=1&sn=f7ca68831e0dea08ceb689a5de468112&chksm=8c65b9bfbb1230a994aa2e4147fd96022dc39a66a30b5273c3980ea2cbfab7d44ae43b2e1823#rd'
                  );
                }
              },
              closeBtn: true // 右上角关闭
            });
          } else if (wechatMiniOnlineStatus !== 'AUTH_SUCCESS') {
            // 开通了小麦收银、没有完成微信认证
            Vue.$confirm({
              title: '温馨提示',
              text: '当前未完成小麦收银微信认证,请您完成【微信认证】后再来发布小麦秀。',
              cancleText: '继续制作',
              okText: '前往认证',
              cancle: () => {
                this.handleToMakeup();
              },
              ok: () => {
                if (this.XMCounter) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/wechatNotice?channelStatusDetail=${JSON.stringify(res.result)}${
                      this.enterType ? `&enterType=${this.enterType}` : ''
                    }`;
                  });
                } else {
                  Vue.$toast.error('无【小麦收银】权限，请联系管理员（主账号）');
                }
              },
              closeBtn: true // 右上角关闭
            });
          } else {
            this.handleToMakeup();
          }
        } else if (this.activityType === 'distributeType'||this.activityType === 'distributeGroupType') {
          if (xmPayRegisterStatusEnum !== 'SUCCESS') {
            // 未开通小麦收银
            Vue.$confirm({
              title: '温馨提示',
              text: '小麦秀收款需开通小麦收银，且完成小麦收银-微信认证，如需收款请联系主账号前往小麦助教APP开通小麦收银后完成认证后再来发布小麦秀。',
              cancleText: '取消',
              okText: '去开通',
              ok: () => {
                if (this.fromApp) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  if (xmPayRegisterStatusEnum === 'AUDIT_FAIL') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=fail&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else if (xmPayRegisterStatusEnum === 'AUDIT_PROGRESS') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=waiting&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else {
                    location.href =
                      'https://mp.weixin.qq.com/s?__biz=MzIxNDEyODIxMA==&mid=2654820994&idx=1&sn=f7ca68831e0dea08ceb689a5de468112&chksm=8c65b9bfbb1230a994aa2e4147fd96022dc39a66a30b5273c3980ea2cbfab7d44ae43b2e1823#rd';
                  }
                } else {
                  window.open(
                    'https://mp.weixin.qq.com/s?__biz=MzIxNDEyODIxMA==&mid=2654820994&idx=1&sn=f7ca68831e0dea08ceb689a5de468112&chksm=8c65b9bfbb1230a994aa2e4147fd96022dc39a66a30b5273c3980ea2cbfab7d44ae43b2e1823#rd'
                  );
                }
              },
              closeBtn: true // 右上角关闭
            });
          } else if (wechatMiniOnlineStatus !== 'AUTH_SUCCESS') {
            // 开通了小麦收银、没有完成微信认证
            Vue.$confirm({
              title: '温馨提示',
              text: '当前未完成小麦收银微信认证,请您完成【微信认证】后再来发布小麦秀。',
              cancleText: '取消',
              okText: '前往认证',
              ok: () => {
                if (this.XMCounter) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/wechatNotice?channelStatusDetail=${JSON.stringify(res.result)}${
                      this.enterType ? `&enterType=${this.enterType}` : ''
                    }`;
                  });
                } else {
                  Vue.$toast.error('无【小麦收银】权限，请联系管理员（主账号）');
                }
              },
              closeBtn: true // 右上角关闭
            });
          } else {
            this.handleToMakeup();
          }
        } else {
          this.handleToMakeup();
        }
      });
    } else {
      this.handleToMakeup();
    }
  }
  checkUserPermission() {
    if (getUrlParam('instId') && getUrlParam('aid')) {
      const param = {
        instId: getUrlParam('instId'),
        adminId: getUrlParam('aid'),
        groupCode: 'XMCounter'
      };
      fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
        this.XMCounter = res.result;
      });
    } else {
      this.XMCounter = true;
    }
  }
  // 前往制作活动
  handleToMakeup(): void {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    let showUrl: string = '';
    if (env === 'prod') {
      showUrl = 'https://res.xiaomai5.com/xmshow/index2.html#/' + this.activityType + '/edit';
    } else {
      showUrl = (CONFIG.showUrl as any)[env] + this.activityType + '/edit';
    }
    location.href = dealRouterPath(showUrl, 'edit');
  }
}
